<div class="row">
  <div class="col s12">
    <ul class="list">
      <li class="heading">
        <span class="col s3">{{ 'nouns.id' | translate }}</span>
        <span class="col s3">{{ 'customizations.header.name' | translate }}</span>
        <span class="col s3">{{ 'nouns.url' | translate }}</span>
        <span class="col s3">{{ 'nouns.type' | translate }}</span>
      </li>
      <li *ngFor="let document of customization.contentDocuments">
        <span class="col s3">{{ document }} </span>
        <span class="col s3">{{ document.name }} </span>
        <span class="col s3">{{ document.url }} </span>
        <span class="col s3">{{ document.type }} </span>
      </li>
    </ul>
  </div>
</div>
